<template>
  <div class="home">
    <!-- 轮播图  -->   
     <!--  @mouseenter="pauseAutoplay" @mouseleave="resumeAutoplay"  -->
    <div class="home-carousel">
      <swiper :options="swiperOptions" ref="swiperBanner" v-if="bannerList && bannerList.length > 0">
        <swiper-slide v-for="(item,index) in bannerList" :key="index">
          <img :src="item.img" alt="" class="home-carousel-img" v-if="!item.file">
          <video v-else :src="item.file" class="home-carousel-video" :controls="false" muted loop autoplay></video>
          <div class="carousel-caption responsive-caption">
            <h5 class="caption-text">{{ item.title }}</h5>
            <p class="caption-description">{{ item.subheading }}</p>
            <!-- <div class="carousel-caption-btn button--ujarak" @click.stop.prevent="handleSolutionsClick" @touchstart.stop.prevent="handleSolutionsClick">{{ $t('home.oneCont.btn') }}</div> -->
          </div>
        </swiper-slide>
        <!-- 其他 Slides -->
        <div class="swiper-pagination" slot="pagination"></div>
        
      </swiper>
      <div class="pc-fixed-icon" @click="openInquiryForm">
        <img src="@/assets/home/xinxi.png" alt="">
      </div>
    </div>
    <!-- 添加调试信息 -->
    <!-- <div v-else class="no-banner">
      <p>轮播图数据未加载或为空</p>
      <p>bannerList长度: {{ bannerList?.length || 0 }}</p>
    </div> -->
    <!-- 关于KOMO -->
    <div class="home-about" ref="homeAbout">
      <div class="home-about-div">
        <div class="area-title-pc">
          <p>{{ homeData[0]?.value[0]?.title }}</p>
          <p class="area-titleBottom-pc">{{ homeData[0]?.value[0]?.subheading }}</p>
        </div>
        <!-- <h2 class="home-about-h2">{{ homeData[0]?.value[0]?.title }}</h2> -->
        <div class="home-about-cont">
          <div class="home-about-cont-item animate-on-scroll">
            <div class="home-about-cont-item-img">
              <img :src="homeData[0]?.value[0]?.img" alt="KOMO"></img>
            </div>
            <span class="home-about-cont-item-span">{{ homeData[0]?.value[0]?.subheading }}</span>
          </div>
          <div class="home-about-cont-item-pick animate-on-scroll">
            <div class="home-about-cont-item-pick-item">
              <div class="home-about-cont-item-pick-item-title">
                <p class="home-about-cont-item-pick-item-title-p1">{{ homeData[0]?.value[0]?.content_title }}</p>
                <!-- <p class="home-about-cont-item-pick-item-title-p2">{{ homeData[0]?.value[0]?.content_subheading }}</p> -->
              </div>
              <div class="home-about-cont-item-pick-item-cont">
                {{ homeData[0]?.value[0]?.conttent_content }}
              </div>
              <div class="home-about-cont-item-pick-item-cont-btn button--ujarak" @click="$router.push({ path: '/about' })">{{ $t('home.oneCont.btn') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- KOMO Solutions -->
    <div class="home-solutions" ref="homeSolutions">
      <div class="home-solutions-div">
        <div class="home-solutions-cont">
          <div class="area-title-pc">
              <p>{{ homeData[1]?.value[0]?.title }}</p>
              <!-- <p class="home-technology-titleBottom">{{ homeData[2]?.value[0]?.subheading }}</p> -->
          </div>
          <div class="home-solutions-cont-div">
            <!--  @click="$router.push({ path: '/solutions' })" -->
            <div class="home-solutions-cont-div-item animate-on-scroll slide-from-left">
              <div class="home-solutions-cont-div-item-leftImg" @click="handleSolutionsClick(homeData[1]?.value[0]?.left_code)">
                <img :src="homeData[1]?.value[0]?.left_img" alt="">
                <div class="home-solutions-cont-div-item-leftImg-title">
                  <div class="home-solutions-cont-div-item-leftImg-title-bg"></div>
                  <div class="home-solutions-cont-div-item-leftImg-title-font">{{ homeData[1]?.value[0]?.left_img_title }}</div>
                </div>
              </div>
            </div>

            <div class="home-solutions-cont-div-item2"> 
              <div class="home-solutions-cont-div-item2-title area-oneTitle-pc animate-on-scroll slide-from-top">
                <p class="area-titleBottom-pc">{{ homeData[1]?.value[0]?.subheading }}</p>
              </div>

              <div class="home-solutions-cont-div-item-rightImg animate-on-scroll slide-from-top" @click="handleSolutionsClick(homeData[1]?.value[0]?.top_code)">
                <img :src="homeData[1]?.value[0]?.top_img" alt="">
                <div class="home-solutions-cont-div-item-right-title-Width">
                  <div class="home-solutions-cont-div-item-leftImg-title-bg"></div>
                  <div class="home-solutions-cont-div-item-leftImg-title-font">{{ homeData[1]?.value[0]?.top_img_title }}</div>
                </div>
              </div>

              <div class="home-solutions-cont-div-item-leftImg animate-on-scroll slide-from-bottom"
              @click="handleSolutionsClick(homeData[1]?.value[0]?.down_code)">
                <img :src="homeData[1]?.value[0]?.down_img" alt="">
                <div class="home-solutions-cont-div-item-right-title-Width">
                  <div class="home-solutions-cont-div-item-leftImg-title-bg"></div>
                  <div class="home-solutions-cont-div-item-leftImg-title-font">{{ homeData[1]?.value[0]?.down_img_title }}</div>
                </div>
              </div>
            </div>

            <div class="home-solutions-cont-div-item3 animate-on-scroll slide-from-right">
              <div class="home-solutions-cont-div-item-rightImg"
              @click="handleSolutionsClick(homeData[1]?.value[0]?.right_code)">
                <img :src="homeData[1]?.value[0]?.right_img" alt="">
                <div class="home-solutions-cont-div-item-rightImg-title">
                  <div class="home-solutions-cont-div-item-leftImg-title-bg"></div>
                  <div class="home-solutions-cont-div-item-leftImg-title-font">{{ homeData[1]?.value[0]?.right_img_title }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- KOMO Technology -->
    <div class="home-technology" ref="homeTechnology">
      <div class="home-technology-div">
        <div class="area-title-pc">
          <p>{{ homeData[2]?.value[0]?.title }}</p>
          <p class="area-titleBottom-pc">{{ homeData[2]?.value[0]?.subheading }}</p>
        </div>
        <div class="home-technology-cont animate-on-scroll slide-from-bottom">
          <div class="banner-box-swiper">
            <swiper 
              :options="swiperOptionTechnology"
              ref="technologySwiper"
            >
              <swiper-slide class="swiper-slide" v-for="(item,index) in homeData[2]?.value[0]?.content" :key="index">
                <div style="width: 100%;height: 100%;background:#F8F9FC;">
                  <img :src="item.img" alt=""/>
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>

    <!-- KOMO Resolve Specific Issues -->
    <div class="home-Resolve" ref="homeResolve">
      <div class="home-Resolve-div">
        <div class="area-title-pc">
          <p>{{ homeData[3]?.value[0]?.title }}</p>
          <p class="area-titleBottom-pc">{{ homeData[3]?.value[0]?.subheading }}</p>
        </div>
        <div class="home-Resolve-cont animate-on-scroll slide-from-bottom">
          <swiper :options="swiperOptionsResolve" ref="resolveSwiper">
            <swiper-slide class="swiper-slide" v-for="(item,index) in homeData[3]?.value[0]?.content" :key="index">
              <img :src="item.img" alt="" :class="'swiper-resolveCont-imgs' ">
              <div class="swiper-resolveCont" @mouseover="handleMouseOver(index)" 
              @mouseleave="handleMouseLeave(index)">
                <div class="swiper-resolveCont-bg"></div>
                <div class="swiper-resolveCont-cont">
                  <div class="swiper-resolveCont-title">{{ item.img_title }}</div>
                  <div class="swiper-resolveCont-text" v-html="item.img_content"></div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="indicators">
            <div 
              :class="['item', resolveIndex === index ? 'active' : '']"
              v-for="(_, index) in homeData[3]?.value[0]?.content.length"
              :key="index"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-rollimg animate-on-scroll slide-from-bottom">
      <div class="area-rollingTitle-pc">
        <p>{{ $t('solutions.customerReviews.title') }}</p>
      </div>
      <rollingBarrage></rollingBarrage>
    </div>

    <!-- locations -->
    <div class="home-locations">
      <div class="home-locations-div">
        <div class="area-title-pc">
          <p>{{ $t('home.locationsCont.titleTop') }}</p>
          <p class="area-titleBottom-pc">{{ $t('home.locationsCont.titleBottom') }}</p>
        </div>
        <div class="home-locations-cont animate-on-scroll slide-from-bottom">
          <div class="home-locations-map">
            <!-- Google Maps 组件 -->
            <GmapMap
              :center="center"
              :zoom="zoom"
              style="width: 100%; height: 100%"
              :options="{ disableDefaultUI: true }"
            >
              <!-- 地图标记点 -->
              <GmapMarker
                v-for="(marker, index) in locationsData[0]?.value[0]?.content"
                :key="index"
                :position="marker.latitude_and_longitude"
                :icon="{
                  url: require('@/assets/home/dw.png'),
                  scaledSize: { width: 50, height: 50 }
                }"
                @click="onMarkerClick(marker)"
              />
              <!-- 用户当前位置标记 -->
              <GmapMarker
                v-if="userLocation"
                :position="userLocation"
                :icon="userIcon"
              />

              <!-- 信息窗口 -->
              <GmapInfoWindow
                v-if="selectedMarker"
                :options="{ maxWidth: '500',width:'500' }"
                :position="selectedMarker.latitude_and_longitude"
                @closeclick="onInfoWindowClose"
                :visible="isInfoWindowVisible"
              >
                <div class="info-window-content">
                  <div class="info-window-avater">
                    <img :src="selectedMarker.icon" alt="">
                  </div>
                  <div class="info-window-titleCont">
                    <h5>{{ selectedMarker.name }}</h5>
                    <span>{{ selectedMarker.url }}</span>
                  </div>
                  <div class="info-window-body">
                    <div class="info-window-footer">
                      <button @click="navigateToLocation(selectedMarker)"><i class="el-icon-right"></i></button>
                    </div>
                  </div>
                </div>
              </GmapInfoWindow>
            </GmapMap>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import rollingBarrage from '@/components/rollingBarrage.vue'
import { bus } from '@/utils/bus';
import { getBannerListing,getDataList } from '@/api/komo'
let vm = null
export default {
  components: {
    Swiper,
    SwiperSlide,
    rollingBarrage
  },
  data() {
    return {
      // 轮播图banner
      bannerList: [],
      homeData: [],
      locationsData: [],
      swiperOptions: {
        initialSlide: 0,
        pagination: {
          el: '.swiper-pagination', // 分页器的选择器，与上面的类名相对应
          clickable: true, // 允许点击分页器切换幻灯片
          // bulletActiveClass: 'home-swiper-one-active' // 自定义激活的分页器类名
        },
        autoplay: {
          delay: 10000, // 自动切换时间间隔
          disableOnInteraction: false // 用户操作后是否停止自动切换，默认为true
        },
        loop: true, // 循环模式选项
        on: {
          init: function() {
            // 确保初始化时显示第一个slide
            this.slideToLoop(0);
          },
          slideChange: function () {  // 改用function声明
            const swiper = this;
            console.log(swiper)
            document.querySelectorAll('video').forEach(video => {
              video.pause()
              video.currentTime = 0
            })
            
            const currentVideo = document.querySelector(
              `.swiper-slide:nth-child(${swiper.activeIndex + 1}) video`
            )
            if (currentVideo) {
              currentVideo.play().catch(e => {
                currentVideo.muted = true;
                currentVideo.play();
              });
            }
          }
        }
      },

      // technology ==============================
      carouselList: ['','',''], // 轮播图数据
      carouselIndex: 0, // 当前轮播索引
      // 轮播配置项
      swiperOptionTechnology: {
        initialSlide: 0,
        pagination: {
          el: '.swiper-pagination', // 分页器的选择器，与上面的类名相对应
          clickable: true, // 允许点击分页器切换幻灯片
        },
        centeredSlides: true, // 居中显示当前slide
        autoplay: {
          delay: 5000, // 自动切换时间间隔
          disableOnInteraction: false // 用户操作后是否停止自动切换，默认为true
        },
        loop: true, // 无限循环
        // loopAdditionalSlides: 1, // 循环时额外复制的slide数量
        slideToClickedSlide: true, // 点击slide直接切换
        speed: 500,
        spaceBetween: 30,
        slidesPerView: 0.8, // 显示1.2个slide
        effect: 'slide', // 轮播效果
      },
      // technology end ================================

      // resolve ==============================
      resolveIndex: 0, // 当前轮播索引
      resolveSlides: [
        {
          id: 1,
          imgUrl: require('@/assets/home/resolve-1.png'),
          title: this.$t('home.resolve.photoList.titleOne'),
          text: this.$t('home.resolve.photoList.textOne')
        },
        {
          id: 2,
          imgUrl: require('@/assets/home/resolve-2.png'),
          title: this.$t('home.resolve.photoList.titleTwo'),
          text: this.$t('home.resolve.photoList.textTwo')
        },
        {
          id: 3,
          imgUrl: require('@/assets/home/resolve-3.png'),
          title: this.$t('home.resolve.photoList.titleThree'),
          text: this.$t('home.resolve.photoList.textThree')
        },
      ],
      // 设置 swiper 的选项，包括 slidesPerView 来一次显示多个 slides
      swiperOptionsResolve: {
        initialSlide: 0,
        pagination: {
          el: '.swiper-pagination', // 分页器的选择器，与上面的类名相对应
          clickable: true, // 允许点击分页器切换幻灯片
          // bulletActiveClass: 'home-swiper-one-active' // 自定义激活的分页器类名
        },
        on: {
          // 滑动改变时触发
          slideChange: function() {
            vm.resolveIndex = this.realIndex
            console.log(this.realIndex)
          }
        },
        autoplay: {
          delay: 10000, // 自动切换时间间隔
          disableOnInteraction: false // 用户操作后是否停止自动切换，默认为true
        },
        // loop: true, // 无限循环
        // loopAdditionalSlides: 1, // 循环时额外复制的slide数量
        slideToClickedSlide: true, // 点击slide直接切换
        slidesPerView: 3, // 一次显示3个 slides
        spaceBetween: 50, // 设置 slides 之间的间距
        // pagination:{
        //   clickable: true
        // },
        // navigation: true,
        // breakpoints :{
        //   '640': {
        //     slidesPerView: 2,
        //     spaceBetween: 20,
        //   },
        //   '768': {
        //     slidesPerView: 4,
        //     spaceBetween: 40,
        //   },
        //   '1024': {
        //     slidesPerView: 5,
        //     spaceBetween: 50,
        //   },
        // }
      },
      // resolve end ================================

      // locations ================================
      center: { lat: 0, lng: 0 }, // 新加坡坐标
      zoom: 2,
      selectedMarker: null,
      userLocation: null,
      isInfoWindowVisible: false,
      userIcon: {
        url: require('@/assets/home/dqdw.png'),
        scaledSize: { width: 88, height: 88 }
      },
      markers: [
        {
          name: '新加坡',
          position: { lat: 1.3521, lng: 103.8198 },
          icon: {
            url: require('@/assets/home/dw.png'),
            scaledSize: { width: 50, height: 50 }
          },
          description: '新加坡共和国'
        },
        {
          name: '马来西亚',
          position: { lat: 3.1497, lng: 101.6942 },
          icon: {
            url: require('@/assets/home/dw.png'),
            scaledSize: { width: 50, height: 50 }
          },
          description: '马来西亚联邦'
        },
        {
          name: '泰国',
          position: { lat: 13.7563, lng: 100.5018 },
          icon: {
            url: require('@/assets/home/dw.png'),
            scaledSize: { width: 50, height: 50 }
          },
          description: '泰王国'
        },
        {
          name: '印度尼西亚',
          position: { lat: -6.2088, lng: 106.8456 },
          icon: {
            url: require('@/assets/home/dw.png'),
            scaledSize: { width: 50, height: 50 }
          },
          description: '印度尼西亚共和国'
        },
        {
          name: '巴西',
          position: { lat: -53.8496, lng: -8.8856 },
          icon: {
            url: require('@/assets/home/dw.png'),
            scaledSize: { width: 50, height: 50 }
          },
          description: '巴西'
        }
      ],

      // locations end ================================
      observer: null, // Intersection Observer实例
    }
  },
  async created() {
    vm = this // 保存当前实例引用
    await this.initData();
    await this.getLocations();
  },
  methods: {
    // 添加以下两个方法用于控制轮播暂停和恢复
    pauseAutoplay() {
      if (this.$refs.swiperBanner && this.$refs.swiperBanner.$swiper) {
        this.$refs.swiperBanner.$swiper.autoplay.stop();
      }
    },
    resumeAutoplay() {
      if (this.$refs.swiperBanner && this.$refs.swiperBanner.$swiper) {
        this.$refs.swiperBanner.$swiper.autoplay.start();
      }
    },
    // handleSolutionsClick(event) {
    //   console.log('Button clicked!'); // 调试用
    //   event.stopPropagation();
    //   event.preventDefault();

    //   // 添加一个小延迟确保事件完全处理
    //   setTimeout(() => {
    //     this.$router.push({ path: '/solutions' });
    //   }, 100);
    // },
    // 初始化滚动动画观察器
    initScrollAnimation() {
      // 使用Intersection Observer API来观察元素是否进入视口
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('animated');
            }
          });
        }, {
          threshold: 0.1, // 当元素10%可见时触发
          rootMargin: '0px 0px -50px 0px' // 提前50px触发
        });
        
        // 观察所有需要动画的元素
        this.$nextTick(() => {
          const animateElements = document.querySelectorAll('.animate-on-scroll');
          animateElements.forEach(el => {
            this.observer.observe(el);
          });
        });
      } else {
        // 如果浏览器不支持Intersection Observer，直接显示元素
        this.$nextTick(() => {
          const animateElements = document.querySelectorAll('.animate-on-scroll');
          animateElements.forEach(el => {
            el.classList.add('animated');
          });
        });
      }
    },
    async initData () {
      try {
        const result = await getBannerListing('1');
        console.log('Banner数据:', result);
        this.bannerList = result?.data?.list || [];
        console.log('bannerList长度:', this.bannerList.length);
        
        // 数据加载完成后确保Swiper正确初始化
        this.$nextTick(() => {
          if (this.$refs.swiperBanner && this.$refs.swiperBanner.$swiper) {
            console.log('Swiper实例:', this.$refs.swiperBanner.$swiper);
            console.log('当前slide索引:', this.$refs.swiperBanner.$swiper.realIndex);
            // 强制设置到第一个slide
            this.$refs.swiperBanner.$swiper.slideToLoop(0, 0);
          }
        });
        
        const homeDatalist = await getDataList(1);
        this.homeData = homeDatalist?.data?.list;
        console.log('homeData:', homeDatalist);
      } catch (error) {
        console.error('数据加载失败:', error);
        this.bannerList = [];
      }
    },
    async getLocations () {
      const result = await getDataList('6');
      this.locationsData = result?.data?.list;
      this.locationsData[0]?.value[0]?.content.forEach(item => { 
        try {
          if (item.latitude_and_longitude) {
            const coords = item.latitude_and_longitude.split(',')
            if (coords.length === 2) {
              item.latitude_and_longitude = {
                lat: parseFloat(coords[0].trim()),
                lng: parseFloat(coords[1].trim())
              }
            }
          }
        } catch (e) {
          console.error('经纬度转换错误:', e)
          item.coordinates = null
        }
      })
    },
    openInquiryForm(){
      bus.$emit('inquiry-form', true)
    },
    // 轮播图点击跳转方法
    goToLink(index) {
      console.log('点击了第', index, '张图片')
      // 可根据实际需求实现跳转逻辑
    },
    handleMouseOver (index) {
      let imgs = document.querySelectorAll('.swiper-resolveCont-imgs')
      imgs[index].style.filter = 'blur(5px)'
    },
    handleMouseLeave(index) {
      let imgs = document.querySelectorAll('.swiper-resolveCont-imgs')
      imgs[index].style.filter = 'blur(0px)'
    },
    // 获取用户当前位置
    getCurrentPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            
            this.userLocation = { lat, lng };
            this.center = { lat, lng };
            this.zoom = 2;
            
            console.log('用户位置:', lat, lng);
          },
          (error) => {
            console.error('获取位置失败:', error);
            alert('无法获取您的位置，请检查浏览器设置');
          },
          {
            enableHighAccuracy: true, // 高精度
            timeout: 10000, // 超时时间
            maximumAge: 0 // 不缓存位置
          }
        );
      } else {
        alert('您的浏览器不支持地理位置功能');
      }
    },
    // 点击标记点事件
    onMarkerClick (marker) {
      console.log('点击',marker)
      this.selectedMarker = marker;
      this.isInfoWindowVisible = true;
      console.log('信息窗口状态:', this.isInfoWindowVisible);
    },
    onInfoWindowClose () {
      console.log('关闭')
      this.isInfoWindowVisible = false;
      this.selectedMarker = null; // 清除选中的标记
    },
    navigateToLocation(marker) {
      // this.center = marker.position;
      // this.zoom = 12;
      console.log('marker', marker)
      window.open('https://www.baidu.com/', '_blank', 'noopener,noreferrer');
      this.isInfoWindowVisible = false;
      this.selectedMarker = null; // 同时清除选中状态
    },
    handleSolutionsClick (code) {
      console.log('解决方案', code)
      this.$router.push({
        name: 'solutions',
        params: {
          code:code,
        }
      })
    }
  },
  mounted () { 
    // 页面加载时尝试获取用户位置
    this.getCurrentPosition();
    // 确保Swiper正确初始化并从第一个slide开始
    this.$nextTick(() => {
      if (this.$refs.swiperBanner && this.$refs.swiperBanner.$swiper) {
        // 延迟一小段时间确保DOM完全渲染
        setTimeout(() => {
          this.$refs.swiperBanner.$swiper.slideToLoop(0, 0);
          this.$refs.swiperBanner.$swiper.update();
        }, 100);
      }
    });
    this.initScrollAnimation();
  },
  beforeDestroy() {
    // 清理观察器
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  deactivated() { // keep-alive组件停用时
    this.$refs.swiper?.$swiper?.slideTo(0); // 复位到第一张
    this.$refs.videoRefs?.forEach(v => {
      v.pause();
      v.currentTime = 0;
    });
  }
};
</script>

<style scoped>
/* 添加样式 */
.home {
  width: 100%;
  height: 100%;
  background: #F8F9FC;
}

/* 轮播 ============================= */
.home-carousel{
  position: relative;
  width: 100%;
  height: 46vw; /* 确保有高度 */
}
.home-carousel .swiper-container {
  width: 100%;
  height: 100%; /* 根据需要调整高度 */
  /* background-image: url(@/assets/home/banner.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;
  object-fit: inherit; */
  position: relative; 
}
.home-carousel .slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home-carousel-img,.home-carousel-video{
  width: 100%;
  height: 46vw;
  object-fit: cover;
}
.home-carousel .carousel-caption {
  position: absolute;
  top: 19%;
  left: 7%;
  z-index: 10;
  padding: 20px;
  color: #1e1e1e;
  text-align: left;
}
.no-banner {
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f0f0f0;
  border: 2px dashed #ccc;
}
.home-carousel .caption-text {
  font-size: 4.5rem;
  font-weight: 800;
  color:#ffffff;
  margin-bottom: 2%;
}

.home-carousel .caption-description {
  font-weight: 100;
  font-size: 3rem;
  color: #ffffff;
  margin-bottom: 3%;
}
.home-carousel .carousel-caption-btn{
  width: 14%;
  height: 72px;
  border-radius: 10px;
  border: 1px solid #979797;
  font-size: 2rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  z-index: 9999;
}

.home-carousel .carousel-caption-btn:hover{
  background: #1e1e1e;
}
.home-carousel .carousel-information{
  position: fixed;
  bottom: 0%;
  right: 6%;
  width: 12vw;
  height: 12vw;
  cursor: pointer;
  z-index: 99;
}
.home-carousel .carousel-information img{
  width: 100%;
  height: 100%;
}

/* 轮播 end ============================= */

/* 关于komo ========================== */
.home-about {
  width: 100%;
  margin: 0 auto;
  height: 54vw;
  padding-bottom: 3%;
}
.home-about-div{
  margin-top: 20px;
  width: 80%;
  margin: 0 auto;
  height: 100%;
  position: relative;
  overflow: hidden; /* 防止动画元素溢出 */
}
.home-about-cont-item-img{
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: pointer;
}
.home-about-cont-item-img img{
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease;
}
.home-about-cont-item-img:hover{
  box-shadow: 0px 3px 18px 0px rgb(100 113 93 / 100%);
}
.home-about-cont-item-img:hover img{
  transform: scale(1.2);
}
/* 动画前的初始状态 */
.animate-on-scroll {
  opacity: 0;
  transition: all 3s cubic-bezier(0.2, 0.8, 0.2, 1);
}
/* 左侧元素初始位置 */
.home-about-cont-item.animate-on-scroll {
  transform: translateX(-100px);
}

/* 右侧元素初始位置 */
.home-about-cont-item-pick.animate-on-scroll {
  transform: translateX(100px);
}

.home-about-h2{
  margin: 0;
  padding: 8% 0 5% 0;
  text-align: center;
  font-weight: bold;
  font-size: 4rem;
  color: #1E1E1E;
}
.home-about-cont{
  display: flex;
  position: relative;
  width: 100%;
  height: 66%;
}
.home-about-cont-item{
  width: 40%;
  position: absolute;
  left: 3%;
  top: 0;
  text-align: center;
  z-index: 1;
}
.home-about-cont-item-span{
  font-weight: bold;
  font-size: 2vw;
  color: #D5DCC8;
  margin-top: 2%;
  display: block;
}

.home-about-cont-item-pick{
  width: 60%;
  background: #ECECEC;
  border-radius: 30px;
  /* height: 23vw; */
  position: absolute;
  right: 3%;
  bottom: 13%;
  padding-left: 8%;
}
.home-about-cont-item-pick-item{
  width: 100%;
  height: 100%;
  padding: 6% 4% 3% 0;
}
.home-about-cont-item-pick-item-title{
  width: 100%;
  height: 4vw;
  font-weight: bold;
  color: #1E1E1E;
  padding: 0 2%;
  margin-bottom: 2%;
}
.home-about-cont-item-pick-item-title-p1{
  font-size: 2vw;
  margin: 0;
}
.home-about-cont-item-pick-item-title-p2{
  font-size: 1.8vw;
  margin: 0;
}
.home-about-cont-item-pick-item-cont{
  width: 100%;
  height: 100%;
  font-family: MicrosoftYaHei;
  font-size: 1.4vw;
  color: #959595;
  margin-bottom: 2vw;
}
.home-about-cont-item-pick-item-cont-btn{
    width: 20%;
    height: 42px;
    border-radius: 10px;
    border: 1px solid #979797;
    font-size: 1.4vw;
    color: #1E1E1E;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.home-about-cont-item-pick-item-cont-btn:hover{
  background: #1e1e1e;
}
/* 关于komo end ============================ */

/* solutions komo ========================== */
.home-solutions {
  width: 100%;
  margin: 0 auto;
  background: #D5DCC880;
  padding: 0 0 5%;
}
.home-solutions-div{
  margin-top: 20px;
  width: 80%;
  margin: 0 auto;
  height: 100%;
  position: relative;
  overflow: hidden; /* 防止动画元素溢出 */
}
.home-solutions-title{
  margin: 0;
  padding: 8% 0 5% 0;
  text-align: center;
  font-weight: bold;
  font-size: 4rem;
  color: #1E1E1E;
}
.home-solutions-titleBottom{
  font-size: 1.5rem;
}
.home-solutions-cont{
  position: relative;
}
.home-solutions-cont-div{
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  gap: 1.5%;
}
.home-solutions-cont-div-item,
.home-solutions-cont-div-item2,
.home-solutions-cont-div-item3{
  display: flex;
  height: 43vw;
  width: calc(100% / 3);
  gap: 1.5%;
}
.home-solutions-cont-div-item2{
  flex-direction: column;
}
.home-solutions-cont-div-item2-title{
  padding: 2% 2% 0;
}
/* 从左侧滑入 */
.slide-from-left {
  transform: translateX(-200px);
}

/* 从右侧滑入 */
.slide-from-right {
  transform: translateX(200px);
}

/* 从上侧滑入 */
.slide-from-top {
  transform: translateY(-200px);
}

/* 从下侧滑入 */
.slide-from-bottom {
  transform: translateY(200px);
}

/* 动画激活状态 */
.animate-on-scroll.animated {
  opacity: 1;
  transform: translateX(0) translateY(0);
}
.home-solutions-cont-div-item-leftImg{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden; /* 确保图片超出容器部分被隐藏 */
  border-radius: 1rem;
}
.home-solutions-cont-div-item-leftImg img{
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease; /* 平滑过渡效果 */
  object-fit: cover;
}
.home-solutions-cont-div-item-leftImg img:hover,.home-solutions-cont-div-item-rightImg img:hover {
  transform: scale(1.2); /* 鼠标悬停时放大1.2倍 */
}
.home-solutions-cont-div-item-leftImg-title,.home-solutions-cont-div-item-right-title-Width,.home-solutions-cont-div-item-rightImg-title{
  position: absolute;
  left: 3%;
  top: 2%;
  width: 36%;
  height: 7%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-solutions-cont-div-item-leftImg-title-bg{
  background: #FFFFFF;
  opacity: 0.6;
  position: absolute;
  border-radius: 60px;
  width: 100%;
  height: 100%;
}
.home-solutions-cont-div-item-leftImg-title-font{
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 1.5vw;
  color: #1E1E1E;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.home-solutions-cont-div-item-rightImg{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden; /* 确保图片超出容器部分被隐藏 */
  border-radius: 1rem;
}
.home-solutions-cont-div-item-rightImg img{
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease; /* 平滑过渡效果 */
  object-fit: cover;
}
.home-solutions-cont-div-item-right-title-Width{
  height: 16%;
}
.home-solutions-cont-div-item-rightImg-title{
  width: 75%;
}

/* solutions komo end ============================ */

/* technology komo ========================== */
.home-technology {
  width: 100%;
  margin: 0 auto;
  /* background: #F8F9FC; */
  padding-bottom: 5%;
}
.home-technology-div{
  margin-top: 20px;
  width: 80%;
  margin: 0 auto;
  height: 100%;
  position: relative;
  overflow: hidden; /* 防止动画元素溢出 */
}
.home-technology-title{
  margin: 0;
  padding: 8% 0 5% 0;
  text-align: center;
  font-weight: bold;
  font-size: 4rem;
  color: #1E1E1E;
}
.home-technology-titleBottom{
  font-size: 1.5rem;
}
.home-technology-cont{
  position: relative;
}

.home-technology-cont .banner-box-swiper {
  width: 100%;
  /* height: 680px; */
  height: 500px;
  overflow: hidden; 
  position: relative;
  border-radius: 48px;
}
.home-technology-cont .swiper-container {
  width: 100%;
  height: 100%;
  overflow: visible;
}
.home-technology-cont .swiper-slide {
  text-align: center;
  transition: 300ms;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.home-technology-cont .swiper-slide img{
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition:1s linear 2s;
	transform:scale(1.1,1.1);
}
.home-technology-cont .swiper-slide-active img{
	transition:3s linear;
	transform:scale(1,1);
}	
.home-technology-cont .img-container {
  width: 100%;
  height: 100%;
  padding: 6px;
}
.home-technology-cont .img-container img {
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
}
      
/* 左侧轮播项样式 */
.home-technology-cont .swiper-slide-prev {
  width: 450px;
  height: 485px;
}
.home-technology-cont .swiper-slide-prev img{
  width: 100%;
  height: 100%;
}

/* 右侧轮播项样式 */
.home-technology-cont .swiper-slide-next {
  width: 450px;
  height: 485px;
} 
.home-technology-cont .swiper-slide-next img{
  width: 100%;
  height: 100%;
}          
  
.home-technology-cont .indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px 0;
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: 100%;
}
  
.home-technology-cont .indicators .item {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: 10px;
  background: #959595;
}
.home-technology-cont .indicators .active {
  background: #ffffff;
}
.home-technology-cont :deep(.swiper-wrapper){
    align-items: center;
}

/* technology komo end ========================== */
/* Resolve ===================================== */
.home-Resolve {
  width: 100%;
  margin: 0 auto;
  background: #D5DCC880;
  padding-bottom: 5%;
}
.home-Resolve-div{
  margin-top: 20px;
  width: 80%;
  margin: 0 auto;
  height: 100%;
  position: relative;
  overflow: hidden; /* 防止动画元素溢出 */
}
.home-Resolve-title{
  margin: 0;
  padding: 8% 0 5% 0;
  text-align: center;
  font-weight: bold;
  font-size: 4rem;
  color: #1E1E1E;
}
.home-Resolve-titleBottom{
  font-size: 1.5rem;
}
.home-Resolve-cont{
  width: 100%;
}
.home-Resolve-cont .swiper-slide{
  height: 62vh;
  position: relative;
} 
.home-Resolve-cont .swiper-slide img{
  width: 100%;
  height: 100%;
  transition: filter 0.5s ease;
}
.home-Resolve-cont .swiper-resolveCont{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  transition: transform 0.8s ease;
  transform: translateY(81%);

}

.home-Resolve-cont .swiper-resolveCont:hover{
  transform: translateY(0px);
}
.home-Resolve-cont .swiper-resolveCont:hover .swiper-resolveCont-bg{
  border-radius: 14px 14px;
}

.home-Resolve-cont .swiper-resolveCont-bg{
  background: #1E1E1E;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  border-radius: 0px 0px 30px 30px;
  opacity: 0.6;
  position: absolute;
  bottom: 0;
  width: 100%;
  height:100%;
  border-radius: 0 0 28px 28px;
}
.home-Resolve-cont .swiper-resolveCont-cont{
  position: absolute;
  bottom: 0;
  width: 100%;
  height:100%;
  display: flex;
  align-items: center;
  /* justify-content: space-evenly; */
  flex-direction: column;
  padding: 6%;
}
.home-Resolve-cont .swiper-resolveCont .swiper-resolveCont-title{
  font-weight: bold;
  font-size: 1.2vw;
  color: #FFFFFF;
  opacity: 1;
  padding-bottom: 3%;
}
.home-Resolve-cont .swiper-resolveCont .swiper-resolveCont-text{
  font-size: 1.2vw;
  color: #FFFFFF;
  opacity: 1;
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  height: 86%;
  font-weight: 100;
  overflow-y: auto;
  padding: 0 2%;
}
/* 整体滚动条容器 */
.home-Resolve-cont .swiper-resolveCont .swiper-resolveCont-text::-webkit-scrollbar {
  width: 8px;       /* 竖向滚动条宽度 */
  height: 10px;      /* 横向滚动条高度 */
  background: transparent; /* 轨道背景色 */
}

/* 滚动条轨道 */
.home-Resolve-cont .swiper-resolveCont .swiper-resolveCont-text::-webkit-scrollbar-track {
  border-radius: 5px;
  background: transparent;
  box-shadow: inset 0 0 3px rgba(0,0,0,0.1);
  border-radius: 10px;
}

/* 滚动条滑块 */
.home-Resolve-cont .swiper-resolveCont .swiper-resolveCont-text::-webkit-scrollbar-thumb {
  background: #a1a1a1;
  border-radius: 5px;
  border: 2px solid transparent; /* 透明边框增强视觉效果 */
  background-clip: content-box;  /* 避免背景色溢出 */
}

/* 滑块悬停状态 */
.home-Resolve-cont .swiper-resolveCont .swiper-resolveCont-text::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 滚动条角落 */
.home-Resolve-cont .swiper-resolveCont .swiper-resolveCont-text::-webkit-scrollbar-corner {
  background: transparent;
}

.home-Resolve-cont .indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3% 0 0;  
}
  
.home-Resolve-cont .indicators .item {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: 10px;
  background: #959595;
}
.home-Resolve-cont .indicators .active {
  background: #1e1e1e;
}
/* Resolve end ===================================== */
.home-rollimg{
  width: 80%;
  margin: 4% auto;
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  border-radius: 30px;
  padding: 0 0 4%;
}
/* locations ===================================== */
.home-locations {
  width: 100%;
  margin: 3% auto 0;
  padding-bottom: 5%;
  background-image: url("@/assets/home/Shape.png");
  background-repeat: no-repeat;
}
.home-locations-div{
  margin-top: 20px;
  width: 80%;
  margin: 0 auto;
  height: 100%;
}
.home-locations-title{
  margin: 0;
  padding: 5% 0 5% 0;
  text-align: center;
  font-weight: bold;
  font-size: 4rem;
  color: #1E1E1E;
}
.home-locations-titleBottom{
  font-size: 1.5rem;
}
.home-locations-cont{
  
}
.home-locations-map{
  width: 100%;
  height: 600px;
  border: 1px solid #000000;
  position: relative;
}
.home-locations-map .map-controls {
  position: absolute;
  top: 10px;
  right: 10px;
  background: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

.home-locations-map .info-window-content {
  padding: 0 10px 10px 10px;
  font-size: 14px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  gap: 3%;
  align-items: center;
}
.info-window-avater{
  width: 80px;
  height: 80px;
}
.info-window-avater img{ 
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}
.info-window-titleCont{

}

.home-locations-map .info-window-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.home-locations-map .close-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
}

.home-locations-map .close-button:hover {
  color: #333;
}

.home-locations-map .info-window-body {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.home-locations-map .info-window-footer {
  text-align: right;
}

.home-locations-map .info-window-footer button {
  padding: 5px 10px;
  background-color: #1e1e1e;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.5vw;
}

.home-locations-map .info-window-footer button:hover {
  background-color: #000;
}
/* locations end ===================================== */

.button--ujarak, .button--ujarak::before {
  -webkit-transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}
.button--ujarak {
  -webkit-transition: border-color 0.4s, color 0.4s;
  transition: border-color 0.4s, color 0.4s;
}
.button--ujarak:hover {
  color: #fff;
}
.home-carousel :deep(.swiper-pagination-bullet-active){
  background: #1E1E1E !important; /*修改为你需要的颜色*/
}
.home-carousel :deep(.swiper-pagination-bullet),.home-technology :deep(.swiper-pagination-bullet){
  width: 20px;
  height: 20px;
}
.home-technology :deep(.swiper-pagination-bullet){
  background: #959595;
  opacity: 1;
}
.home-technology :deep(.swiper-pagination-bullet-active){
  background: #ffffff !important; /*修改为你需要的颜色*/
}


@media (max-width: 1910px) {
  .home-locations {
    background-position: right;
  }
}
@media (max-width: 1800px) {
  /* 轮播图 ========================== */
  /* 轮播图 end============================ */
}

@media (max-width: 1700px) {
  /* 轮播图 ========================== */
   .home-carousel .caption-text {
    font-size: 4rem;
  }
  .home-carousel .caption-description {
    font-size: 2.5rem;
  }
  /*.home-carousel .carousel-caption-btn {
    font-size: 1.8rem;
  } */
  /* 轮播图 end============================ */
 
}

@media (max-width: 1685px) {
  /* 轮播图 ========================== */
  /* .home-carousel .carousel-caption {
    bottom: 42%;
  }
  .home-carousel .caption-text {
    font-size: 3.2rem;
  }
  .home-carousel .caption-description {
    font-size: 2rem;
  }
  .home-carousel .carousel-caption-btn {
    width: 12%;
    height: 50px;
    font-size: 1.5rem;
  } */
  /* 轮播图 end============================ */
}
@media (max-width: 1600px) {

  .home-Resolve-cont .swiper-resolveCont{
    /* transform: translateY(71%); */
  }
  /* .home-Resolve-cont .swiper-resolveCont-cont{
    padding: 5% 5%;
  } */
}
@media (max-width: 1530px) {
  /* 轮播图 ========================== */
  /* .home-carousel .carousel-caption {
    left: 3%;
  } */
  /* 轮播图 end============================ */
  /* .home-Resolve-cont .swiper-resolveCont{
    transform: translateY(78%);
  } */

}
@media (max-width: 1480px) {
  /* 轮播图 ========================== */
  /* .home-carousel .carousel-caption {
    bottom: 47%;
  }*/
  .home-carousel .caption-text {
    font-size: 3.5rem;
  }
  .home-carousel .caption-description {
    font-size: 2.5rem;
  }
  .home-carousel .carousel-caption-btn {
    font-size: 1.8rem;
  }
  /* 轮播图 end============================ */
  .home-solutions-cont-div-item-leftImg-title-font{
    font-size: 1.8rem;
  }
  /* .home-Resolve-cont .swiper-resolveCont{
    transform: translateY(80%);
  } */
}

@media (max-width: 1380px) {
  /* 轮播图 ========================== */
  /* .home-carousel .carousel-caption {
    bottom: 45%;
  }
  .caption-text {
    font-size: 2.2rem;
  }
  .caption-description {
    font-size: 1.2rem;
  }
  .carousel-caption-btn {
    width: 10%;
    height: 40px;
    font-size: 1rem;
  } */
  /* 轮播图 end============================ */
  .home-about-cont-item-span {
    font-size: 1.5rem;
  }
  /* .home-Resolve-cont .swiper-resolveCont {
    transform: translateY(80%);
  } */
}
@media (max-width: 1320px) {
  /* 轮播图 ========================== */

  .home-carousel .caption-text {
    font-size: 3.2rem;
  }
  .home-carousel .caption-description {
    font-size: 2.2rem;
  }
  .home-carousel .carousel-caption-btn {
    font-size: 1.6rem;
    width: 16%;
    height: 64px;
  }
  /* 轮播图 end============================ */
}
@media (max-width: 1300px) {
  /* 轮播图 ========================== */
  .carousel-item{

  }
  /* .carousel-caption {
    bottom: 45%;
  }
  .caption-text {
    font-size: 2rem;
  }
  .caption-description {
    font-size: 1rem;
  }
  .carousel-caption-btn {
    width: 10%;
    height: 40px;
    font-size: 1rem;
  } */
  /* 轮播图 end============================ */
}

/* 响应式布局 */
@media (max-width: 767.98px) {
  .home-carousel .carousel-caption {
    left: 50%;
    bottom: 10%;
    transform: translateX(-50%);
    text-align: center; /* 移动端居中对齐后改为上方显示，但这里先设为居中以便后续调整 */
  }

  /* 进一步调整以确保文字在移动端显示在上方 */
  .responsive-caption {
    position: absolute;
    top: 10%; /* 调整为上方显示 */
    left: 50%;
    transform: translateX(-50%);
    width: 100%; /* 可选，根据需求调整宽度 */
    text-align: center; /* 可选，根据需求调整对齐方式，但这里为了上方显示已设为居中 */
  }

  /* 注意：由于.responsive-caption已经包含了.carousel-caption的样式，并且进行了覆盖，
   * 所以.carousel-caption中的text-align: center;在移动端实际上不会生效。
   * 这里保留是为了展示如何通过媒体查询进行样式覆盖和调整。
   */
}
</style>